<template>
  <div class="result-ctas--wrap">
    <p class="intro--text-result">
      {{
        $i18n.locale == 'it' ?
        `Grazie per aver mangiato con me al ristorante sostenibile!
        Spero che tutto sia stato delizioso e nutriente! 
        Ma, soprattutto, spero tu non abbia fatto scelte troppo costose, perché… ecco lo scontrino!`
        :
        `Thanks for dining at the Healthy Sustainable Restaurant with me today!
         Hope everything was both delicious and nutritious!
         But most importantly, I hope you made some good cheap choices because here’s your bill!`
      }}
    </p>
    <div class="ctas--holder">
      <div class="cta-result cta-positive"
        @click="showTicket"
      >
        {{
          $i18n.locale == 'it' ?
          "Voglio vedere il conto!"
          :
          "I’m ready to see the bill!"
        }}
      </div>
      <div class="cta-result cta-negative"
        @click="resetSelection"
      >
        {{
          $i18n.locale == 'it' ?
          "Voglio cambiare piatti"
          :
          "I want to change dishes"
        }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ResultCtaVassoio",
    props: ['resetSelection', 'showTicket']
  }
</script>
<style lang="scss" >
  .result-ctas--wrap{
    position: absolute;
    top: 20%;
    z-index: 5;
    opacity: 0;
    width: 100%;
    text-align: center;
    visibility: hidden;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    @media screen and(max-width: 860px){
      top: 10%;
      width: auto;
      padding: 0 20px;
    }
    .intro--text-result{
      font-size: 24px;
      max-width: 70%;
      margin: 0 auto;
      @media screen and(max-width: 860px){
        font-size: 18px;
        max-width: 100%;
      }
    }
    .ctas--holder{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      .cta-result{
        padding: 30px 40px;
        cursor: pointer;
        opacity: 1;
        transition: opacity .5s ease-in-out;
        border-radius: 5px;
        color: #000;
        &:hover{
          opacity: .75;
        }
        &.cta-positive{
          background-color: #fff;
          margin-right: 10px;
        }
        &.cta-negative{
          border: 1px solid #000;
          margin-left: 10px;
        }
      }
      @media screen and(max-width: 860px){
        flex-direction: column;
        .cta-result{
          padding: 10px 20px;
          width: 250px;
          font-size: 16px;
          line-height: 24px;
          align-self: stretch;
          justify-content: center;
          display: flex;
          align-items: center;
          &.cta-positive,&.cta-negative{
            margin: 0 auto 15px;
          }
        }
      }
    }
  }
</style>